export enum FormTypes{
  PERSONAL_INJURY = 1,
  SOCIAL_SECURITY = 2,
  VETERAN_AFFAIRS = 3,
  WORKERS_COMP = 4,
  MEDICARE = 5,
  CUSTOM = 6
}
